<template>
  <div class="flex_between flex_col wrap">
    <div class="searchNavBar flex flex_start">
      <van-search placeholder="请输入搜索关键词" shape="round" :background="m_color" style="width: 100%"
                  @click="$router.push('/common/search')">
      </van-search>
      <div class="msgBox">
        <!--          <img @click="pushTo('/nearshop')" style="margin-right: .1rem;" class="mes" src="../../assets/image/common/shangquan.png" alt="">-->
        <img @click="$router.push('/me/message/list')" src="@/assets/image/common/xiaoxi_kong.png" v-if="isMsg===0"
             alt="">
        <img @click="$router.push('/me/message/list')" src="@/assets/image/common/xiaoxi.png" v-else alt="">
      </div>
    </div>
    <!-- 加载分类 -->
    <div class="tabBox">
      <van-tabs :active="tabIndex" :swipe-threshold="5" background="#E61B1B" color="#ffffff"
                title-active-color="#ffffff" title-inactive-color="#ffffff" :border="false" :ellipsis="false"
                @click="changeTab">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name" :offset-top="50">
        </van-tab>
      </van-tabs>
    </div>
    <!--占绝对定位的高度-->
    <div style="height: 100px;"></div>
    <!-- 加载分类对应的具体页面 -->
    <van-swipe :initial-swipe="tabIndex" :show-indicators="false" :touchable="true" @change="changeSwiper">
      <van-swipe-item class="swiper-item" v-for="(item, index) in tabs" :key="index">
        <div class="scroll-v list" v-if="tabIndex==index">
          <!-- 加载精选页 -->
          <fine v-if="index==0"></fine>
          <top100 v-if="index==1"></top100>
          <!-- 加载淘宝分类产品页 -->
          <cate v-if="index>1" :cateId="item.id" :uptab="item"></cate>
        </div>
      </van-swipe-item>
    </van-swipe>
    <!--底部菜单-->
    <foot-bar :active="0"></foot-bar>
  </div>
</template>

<script>
import fine from './fine.vue'
import top100 from './top100.vue'
import cate from './cate.vue'
import {taoCate1List} from "../../../api/commonV2";

export default {
  components: {
    fine,
    top100,
    cate
  },
  data() {
    return {
      tabs: [], //精选+分类
      tabIndex: 0,
      dataList: [], // 列表数据
      isMsg: 0,//新消息数量
    }
  },
  created() {
    this.getTaoCate1List() //首页顶部的菜单
  },
  methods: {
    getTaoCate1List() {
      let data = {}
      taoCate1List(data).then(res => {
        if (res.result === '0') {
          //添加默认第一项
          let tabs = [{
            icon: '',
            name: '精选',
            id: '0'
          }, {
            icon: '',
            name: 'TOP100',
            id: '0'
          }]
          //追加拼多多分类
          this.tabs = tabs.concat(res.dataList)
        }
      }, err => {
      })
    },
    changeTab(index) {
      this.tabIndex = index
    },
    changeSwiper(index) {
      this.tabIndex = index
    },
  }
}
</script>

<style scoped lang="less">
.wrap {
  height: 100vh;
}

.msgBox {
  width: 10%;

  img {
    width: 20px;
  }
}

.navBox {
  width: 100%;

  .scan {
    margin-left: 10px;
    margin-right: 10px;
  }

  .search {
    width: 70%;
  }
}

/*控制首页的tabs的背景色，不可删除*/
/deep/ .van-tabs__scroll {
  background-color: #E61B1B !important;
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/home/index.vue